<template>
  <div class="container report">
    <div class="searchCondition">
      <span class="utc">UTC-0</span>
      <el-date-picker
        v-model="where.date"
        type="monthrange"
        :clearable="false"
        start-placeholder="from"
        end-placeholder="to"
        value-format="yyyy-MM"
		size="mini"
      >
      </el-date-picker>
      <el-select size="mini" v-model="where.status" placeholder="status" clearable>
            <el-option
      v-for="item in statusOption"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :class="item.class"
      >
    </el-option>
      </el-select>
      <el-input
        v-model="where.offer_id"
        style="width: 300px"
        placeholder="Offer id or App id"
        clearable
		size="mini"
      ></el-input>
      <el-button size="mini" @click="search">Search</el-button>
      <!-- <exportcsv :rows="rows" filename="OfferPayment" :tableObj="$refs.table"></exportcsv> -->
	  <el-button :disabled="downLoading" :loading="downLoading" size="mini" icon="el-icon-download" @click="getFile"></el-button>

    </div>
    <el-table
      :data="rows"
      height="250"
      border
      stripe
      class="table"
      v-loading="loading"
      header-row-class-name="table-header"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="table"
    >
      <el-table-column prop="time" label="Month" width="100"> </el-table-column>
      <!-- <el-table-column prop="aff_id" label="Pub Id" width="120"> </el-table-column> -->
      <!-- <el-table-column prop="aff_name" label="Publisher" width="150"> -->
      <!-- </el-table-column> -->
      <el-table-column prop="offer_id" label="Offer Id" width="120">
      </el-table-column>
      <el-table-column prop="offer_name" label="Offer Name" width="420"> </el-table-column>
      <el-table-column label="Conv">
		<el-table-column prop="conv" :label="summary.conv || '--'">
		</el-table-column>
      </el-table-column>
      <el-table-column label="Revenue($)">
		<el-table-column prop="rev" :label="summary.status_amount || '--'">
		</el-table-column>
      </el-table-column>
      <el-table-column label="Deduct Rev" >
		<el-table-column prop="deducted_rev" :label="summary.deducted_rev || '--'">
		</el-table-column>
      </el-table-column>
      <el-table-column label="Final Rev" >
		<el-table-column prop="final_rev" :label="summary.final_rev || '--'">
		</el-table-column>
      </el-table-column>
      <el-table-column prop="status" label="Status">
        <span slot-scope="sp" :class="'status-' + sp.row.status.trim()">{{
          sp.row.status.toUpperCase()
        }}</span>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[60,80,200]"
    >
    </el-pagination>
  </div>
</template>
<script>
import { post, downloadCsv } from "@/lib/channelClient";
import exportcsv from '@/components/channelClient/exportcsv.vue';

const current = new Date();
current.setMonth(current.getMonth() - 1);
const currentMonth = current.toISOString().substr(0, 7);
export default {
	components:{
		exportcsv,
	},
	data() {
		return {
			where: {
				date: [currentMonth, currentMonth],
				offer_id: "",
				status:"",
			},
			rows: [],
			summary: {},
			final_rev:0,
			deducted_rev:0,
			total: 0,
			limit: 60,
			page: 1,
			revenueTotal: 0,
			loading: false,
			downLoading: false,
			statusOption:[
				{
					value:'deducted',
					label:'Deducted',
					class:'status-deducted'
				},
				{
					value:'processing',
					label:'Processing',
					class:'status-processing'
				},
				{
					value:'hold on',
					label:'Hold On',
					class:'status-holdon'
				},
				{
					value:'confirm',
					label:'Confirm',
					class:'status-confirm'
				},
				{
					value:'confirmdelay',
					label:'Confirm delay',
					class:'status-confirm'
				},
			]
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async search() {
			await new Promise((res) => setTimeout(res, 0));
			const where = this.where;
			const limit = this.limit;
			const offset = (this.page - 1) * limit;
			this.loading = true;
			const res = await post("/channelClient/offerPayment", {
				where,
				limit,
				offset,
			});
			this.loading = false;
			if (res.status != 200) {
				const text = await res.text();
				if (/login/.test(text)) {
					window.location.href = "/login";
					return;
				}
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			this.rows = body.rows;
			this.total = body.count;
			// this.final_rev = body.final_rev;
			// this.deducted_rev = body.deducted_rev;
			this.summary = body.summary;
		},
		async getFile() {
			await new Promise((res) => setTimeout(res, 0));
			const where = this.where;
			const limit = 0;
			const offset = 0;
			this.downLoading = true;
			const res = await post("/channelClient/offerPayment", {
				where,
				limit,
				offset,
			});
			this.downLoading = false;
			if (res.status != 200) {
				const text = await res.text();
				if (/login/.test(text)) {
					window.location.href = "/login";
					return;
				}
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			downloadCsv(body.rows, 'OfferPayment', this.$refs.table)
		}
		// async pageChange(page) {
		// 	this.page = page;
		// 	await this.search();
		// },
		// async	pageSizeChange(pageSize) {
		// 	this.pageSize = pageSize;
		// 	await this.refresh();
		// }
	},
};
</script>
<style scoped>


</style>
